import React, { useState, useContext, useEffect } from "react";
import { TaskContext } from "../components/TaskContext";
import { Form, Row, Col } from "react-bootstrap";
import { TextField, InputLabel } from "@mui/material";
import { marginBottom } from "../App";
import Button from "@mui/material/Button";
import { UserDataContext } from "../components/UserDataContext";
import TaskChatStory from "./TaskChatStory";
import Alerts from "../components/Alerts";
import { apiRequest } from "../components/Config";

export default function TaskChat() {
  const { taskId } = useContext(TaskContext);
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [error, setError] = useState("");
  const { userData } = useContext(UserDataContext);
  const [performer, setPerformer] = useState(null);
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [apiResponse, setApiResponse] = useState({});
  const [insertId, setInsertId] = useState("");

  const handleContentChange = (event) => {
    const value = event.target.value;
    setContent(value);
    //console.log(value);
    if (value.length > 2000) {
      setError("Treść zlecenia nie może przekraczać 2000 znaków.");
    } else {
      setError("");
    }
  };
  const handleTitleChange = (event) => {
    const value = event.target.value;
    setTitle(value);
    //console.log(value);
    if (value.length < 1) {
      setError("Nie podano tematu korespondencji.");
    } else {
      setError("");
    }
  };

  const handleSubmit = async () => {
    const values = {
      taskId: taskId,
      title: title,
      content: content,
    };

    try {
      const response = await apiRequest("newmail", "POST", values);
      console.log("Chat response: ", response);
      if (response.error_msg === "sent") {
        setInsertId(response.lastInsertId);
        setShowApiResponse(true);
        setApiResponse({
          title: "Sukces",
          severity: "success",
          info: "Wiadomość wysłana!",
        });
        setTitle("");
        setContent("");
      }
    } catch (error) {
      console.error("Błąd: ", error);
    }
  };

  useEffect(() => {
    if (userData) {
      const fetchData = async () => {
        try {
          const response = await apiRequest(`taskPerformer/${taskId}`, "GET");
          setPerformer(response[0].performer);
          //console.log("Performer: ", response[0].performer);
        } catch (error) {
          console.error(error.message);
        }
      };
      fetchData();
    }
  }, [userData]);

  return (
    <div>
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      {userData && performer !== null ? (
        <>
          <Row style={{ marginBottom }}>
            <Col>
              <InputLabel id="content-label">
                Korespondencja od: <b>{userData.fullName}</b>
              </InputLabel>
              <Form.Group controlId="formTitle">
                <TextField
                  type="text"
                  name="title"
                  label="Temat korespondencji"
                  fullWidth
                  variant="outlined"
                  value={title}
                  onChange={handleTitleChange}
                  error={Boolean(error)}
                  helperText={error}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row style={{ marginBottom }}>
            <Col style={{ marginBottom }}>
              <Form.Group controlId="formContent">
                <TextField
                  type="text"
                  name="content"
                  label="Treść korespondencji"
                  fullWidth
                  multiline
                  minRows={3}
                  variant="outlined"
                  value={content}
                  onChange={handleContentChange}
                  error={Boolean(error)}
                  helperText={error}
                />
              </Form.Group>
              <br></br>
              <Button type="submit" variant="outlined" onClick={handleSubmit}>
                Wyślij
              </Button>
            </Col>
          </Row>
        </>
      ) : (
        <p className="p5">
          Utworzenie korespondencji jest możliwe po przydzieleniu Wykonawcy do
          Zlecenia.
        </p>
      )}
      <TaskChatStory insertId={insertId} />
    </div>
  );
}
